import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { AlertComponent } from './alert/alert.component';
import { CustomizedPortfolioAlertsComponent } from './customized-portfolio-alerts/customized-portfolio-alerts.component';
import { ModelCompareDialogComponent } from './model-compare-dialog/model-compare-dialog.component';
import { PartnerPortfolioAlertsComponent } from './partner-portfolio-alerts';
import { ReimportDialogComponent } from './reimport-dialog/reimport-dialog.component';
import { UnsupportedAssetClassesComponent } from './unsupported-import-dialog/unsupported-asset-classes/unsupported-asset-classes.component';
import { UnsupportedImportDialogSkeletonComponent } from './unsupported-import-dialog/unsupported-import-dialog-skeleton/unsupported-import-dialog-skeleton.component';
import { UnsupportedImportDialogComponent } from './unsupported-import-dialog/unsupported-import-dialog.component';
import { UnsupportedSecuritiesComponent } from './unsupported-import-dialog/unsupported-securities/unsupported-securities.component';
import { UnsupportedSleevesComponent } from './unsupported-import-dialog/unsupported-sleeves/unsupported-sleeves.component';

@NgModule({
	declarations: [
		AlertComponent,
		PartnerPortfolioAlertsComponent,
		CustomizedPortfolioAlertsComponent,
		ReimportDialogComponent,
		UnsupportedImportDialogComponent,
		UnsupportedSleevesComponent,
		UnsupportedSecuritiesComponent,
		UnsupportedAssetClassesComponent,
		ModelCompareDialogComponent,
		UnsupportedImportDialogSkeletonComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		AnalyticsModule,
		NgxSkeletonLoaderModule,
		DzButtonModule,
		GenericDirectivesModule,
		DomModule
	],
	exports: [
		AlertComponent,
		PartnerPortfolioAlertsComponent,
		CustomizedPortfolioAlertsComponent
	]
})
export class AlertsModule { }
